import { ProjectsService } from "./../services/projects/projects.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import swal from "sweetalert2";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";

@Component({
  selector: "app-upload-layout",
  templateUrl: "./upload-layout.component.html",
  styleUrls: ["./upload-layout.component.css"],
})
export class UploadLayoutComponent implements OnInit {
  layoutForm: any;
  image: any;
  projects: any;

  files: File[] = []; // for multi imgs plugin

  constructor(
    private formBuilder: FormBuilder,
    private slimLoadingBarService: SlimLoadingBarService,
    private projectService: ProjectsService,
    private errorHandleService: ErrorHandlerService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.getAllProjects();
    this.createForms();
  }

  current_units_arr: any;
  arr: any;
  observableSource = (keyword: any): any => {
    const payload = {
      unit_serial: keyword,
      project_id: this.layoutForm.get("project_id").value,
    };
    if (keyword) {
      this.slimLoadingBarService.start(() => {
        // //console.log('Loading complete');
      });
      return this.http
        .post(
          `${environment.api_base_url}units/search/available_by_serial`,
          payload
        )
        .map((res: any[]) => {
          //console.log(res);
          //console.log(res.data.length);
          this.current_units_arr = res;
          this.slimLoadingBarService.complete();
          if (res.length == 0) {
            //console.log("empty");
            return [];
          } else {
            //console.log(res.data);
            this.arr = [];
            res.forEach((e) => {
              // //console.log(e);
              this.arr.push(e.serial + " (" + e.project.name + ")");
            });
            //console.log(this.arr);
            return this.arr;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  selectedUnits: any[] = [];
  unit_serial = "";
  valueChanged(ev) {
    if (!ev) return;
    const unit = this.current_units_arr.find((element) => {
      return element.serial + " (" + element.project.name + ")" == ev;
    });
    const isUnitSelectedBefore = this.selectedUnits.find((element) => {
      return element.serial + " (" + element.project.name + ")" == ev;
    });
    if (isUnitSelectedBefore) {
      swal("Oops...", "Unit is already selected", "error");
      this.unit_serial = "";
      return;
    }
    this.selectedUnits.push(unit);
    this.unit_serial = "";
  }

  removeUnit(unit) {
    this.selectedUnits = this.selectedUnits.filter((u) => u.id !== unit.id);
  }

  createForms() {
    this.layoutForm = this.formBuilder.group({
      imgs: this.formBuilder.array([]),
      project_id: [""],
    });
  }

  handleUnitLayout(event) {
    let reader: any = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let image = event.target.files[0];
      reader.readAsDataURL(image);
      console.log(image);
      this.image = image.name;
      reader.onload = () => {
        this.layoutForm.get("img").setValue({
          img_name: image.name,
          img_value: (reader.result as any).split(",")[1],
        });
        console.log(this.layoutForm.value);
      };
    }
  }

  onSelect(ev) {
    ev.addedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.layoutForm.get("imgs").push(
          this.formBuilder.group({
            img_name: file.name,
            img_value: (reader.result as any).split(",")[1],
          })
        );
      };
    });
    this.files.push(...ev.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }
  uploadLayout() {
    console.log(this.layoutForm.value);
    this.slimLoadingBarService.start();
    const layout_data = {...this.layoutForm.value, serials: this.selectedUnits.map(unit => unit.serial)};
    console.log(layout_data);
    this.projectService.uploadUnitLayout(layout_data).subscribe(
      (data: any) => {
        swal("Success", "Uploaded unit layout successfully", "success");
        this.createForms();
      },
      (err) => this.errorHandleService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getAllProjects() {
    this.projectService.getProjects().subscribe(
      (data: any) => {
        console.log("projects", data);
        this.projects = data.data;
        console.log(this.projects);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandleService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  onProjectChange() {
    this.selectedUnits = [];
    this.unit_serial = "";
    this.arr = [];
    this.current_units_arr = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/upload-layout/upload-layout.component.ts